import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyOnboarding } from '@/features/my-onboarding'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-onboarding/'
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact', 'supported_employee']),
  component: MyOnboarding,
})
